import { ALL_MENU_ITEM_INGREDIENT_SEARCH_QUERY } from '@/components/menu/search/menu-item-search-queries';
import {
  MenuItemSearch_AllIngredientsQuery,
  MenuItemSearch_AllIngredientsQueryVariables,
} from '@/types';
import { useItemQueryVariables } from './use-item-query-variables';
import { useNewOrderContext } from '@/contexts/new-order-context';
import { useWrappedQuery } from './use-wrapped-query';

export const useLoadAllMenuItemIngredients = () => {
  const itemQueryVariables = useItemQueryVariables();
  const { restaurantUUID, supplierUUID } = useNewOrderContext();

  const { data: allIngredientsResponse, loading: allIngredientsLoading } =
    useWrappedQuery<
      MenuItemSearch_AllIngredientsQuery,
      MenuItemSearch_AllIngredientsQueryVariables
    >(ALL_MENU_ITEM_INGREDIENT_SEARCH_QUERY, {
      fetchPolicy: 'no-cache',
      variables: {
        ...itemQueryVariables,
        restaurantUUID: restaurantUUID!,
        supplierUUID: supplierUUID!,
      },
    });

  return {
    allIngredientsLoading,
    allIngredientsResponse,
  };
};
